<!-- 
Created on April 28  2024
 叉车收藏
@author: xiaolong.li
  -->
<template>
  <div>
    <div
      style="
        height: 146px;
        background: #047bd0;
        padding: 20px;
        text-align: center;
      "
    >
      <h1 style="--bs-text-opacity: 1; text-transform: uppercase !important">
        <span style="color: #ffffff; font-size: 32px">{{
          $t("favorite.停车场")
        }}</span>
      </h1>
    </div>
    <div style="display: flex">
      <div
        style="padding: 50px; width: 500px; padding-left: 100px; display: flex"
      >
        <div style="padding-left: 50px; cursor: pointer">
          <div
            class="image-filter"
            style="justify-content: center; align-items: center; cursor: hand"
          >
            <img
              width="32px"
              class="image"
              height="32px"
              src="@/assets/down.png"
            />
          </div>
          <div class="favourFont" style="width: 150px">
            {{ $t("favorite.导出PDF") }}
          </div>
        </div>
        <div style="padding-left: 80px">
          <a-popconfirm
            title="是否全部删除"
            cancel-text="取消"
            ok-text="确定"
            @confirm="() => delAll()"
          >
            <div
              class="image-filter"
              style="justify-content: center; align-items: center; cursor: hand"
            >
              <img
                width="32px"
                class="image"
                height="32px"
                src="@/assets/del.png"
              />
            </div>
            <div class="favourFont" style="width: 150px; margin-left: 2px">
              {{ $t("favorite.全部删除") }}
            </div>
          </a-popconfirm>
        </div>
      </div>
      <div style="flex: 1; text-align: right; padding: 50px">
        <a-button
          size="small"
          style="
            background-color: #047bd0;
            height: 40px;
            margin-right: 50px;
            font-size: 18px;
            color: white;
            cursor: hand;
          "
          @click="clickQuotation"
        >
          {{ $t("favorite.询价所有装卸车") }}
        </a-button>
      </div>
    </div>
    <div style="width: 95%">
      <div
        style="flex: 1; display: flex; flex-wrap: wrap; justify-content: left"
      >
        <fork-model
          v-for="(item, index) in $store.state.favoriteList"
          :key="index"
          :record="item"
        >
        </fork-model>
      </div>
    </div>
    <div style="display: flex">
      <div
        style="padding: 50px; width: 500px; padding-left: 100px; display: flex"
      >
        <div style="padding-left: 50px; cursor: pointer">
          <div
            class="image-filter"
            style="
              justify-content: center;
              cursor: pointer;
              align-items: center;
            "
          >
            <img
              width="32px"
              class="image"
              height="32px"
              src="@/assets/down.png"
            />
          </div>
          <div class="favourFont" style="width: 150px">导出PDF</div>
        </div>
        <div style="padding-left: 80px">
          <a-popconfirm
            title="是否全部删除"
            cancel-text="取消"
            ok-text="确定"
            @confirm="() => delAll()"
          >
            <div
              class="image-filter"
              style="
                justify-content: center;
                cursor: pointer;
                align-items: center;
                cursor: hand;
              "
            >
              <img
                width="32px"
                class="image"
                height="32px"
                src="@/assets/del.png"
              />
            </div>
            <div class="favourFont" style="width: 150px; margin-left: 2px">
              {{ $t("favorite.全部删除") }}
            </div>
          </a-popconfirm>
        </div>
      </div>
      <div style="flex: 1; text-align: right; padding: 50px">
        <a-button
          size="small"
          style="
            background-color: #047bd0;
            height: 40px;
            margin-right: 50px;
            font-size: 18px;
            color: white;
            cursor: hand;
          "
          @click="clickQuotation"
        >
          {{ $t("favorite.询价所有装卸车") }}
        </a-button>
      </div>
    </div>
    <quotationDlg ref="quotationDlg"></quotationDlg>
  </div>
</template>

<script>
import quotationDlg from "./../project/model/quotation";
import ForkModel from "./model/forkModel.vue";
export default {
  components: { ForkModel, quotationDlg },
  data() {
    return {};
  },
  methods: {
    delAll() {
      if (this.$store.state.favoriteList.length > 0) {
        this.$store.dispatch("setFavoriteMessage", []);
        localStorage.setItem("favoriteJson", {});
      } else {
        this.$notification.error({
          message: "收藏",
          description: "没有加入收藏得叉车!",
        });
      }
    },
    clickQuotation() {
      //if (Object.keys(this.$store.state.userInfo).length > 0) {
      if (this.$store.state.favoriteList.length > 0) {
        this.$refs.quotationDlg.show({ type: "shoucang" });
      } else {
        this.$notification.error({
          message: "收藏",
          description: "没有加入收藏得叉车!",
        });
      }
      // } else {
      //   this.login();
      // }
    },
    login() {
      this.$router.push({ path: "/Login" });
    },
  },
};
</script>

<style scoped>
.content {
  margin-top: 85px; /* 给内容顶部留出足够的空间以避免遮挡头部 */
}
.favourFont {
  font-weight: 700 !important;
  text-align: left !important;
  color: #047bd0;
}
.image {
  border-radius: 50%;
  margin-left: 1px;
  margin-top: 5px;
}
.image-filter {
  display: flex;
  background-color: #047bd0;
  border-color: transparent;
  border-radius: 50%;
  width: 62px;
  height: 65px;
}
</style>
